import { forwardRef } from "react";
function SvgRawRestartIcon({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="#04337A"
        fillRule="evenodd"
        d="M12.867 6.077 6.267 12l6.6 5.923V6.077ZM19.467 6.077 12.867 12l6.6 5.923V6.077Z"
        clipRule="evenodd"
      />
      <path
        stroke="#04337A"
        strokeLinecap="round"
        strokeWidth={1.5}
        d="M4.8 6.462v11.076"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawRestartIcon);
export default ForwardRef;
